import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { TypedMemo } from '../../common/types';
import { SMLContainer } from '../../smartLinks/smlContainer/SMLContainer';

export interface PageUnavailableAction {
  label: string;
  onClick: () => void;
}

interface PageUnavailableProps {
  icon: IconDefinition;
  title: string;
  text: string;
  primary: PageUnavailableAction;
  secondary?: PageUnavailableAction;
  testId: string;
}

/**
 * A full page that says that a page is not there (QA findings brk-1, brk-2). It sits in the normal
 * app shell: a signed-in user keeps the sidebar, and a visitor gets the public top bar. It has a
 * clear way out (the primary action), so a dead link never shows an empty page.
 */
const PageUnavailableComponent: React.FC<PageUnavailableProps> = ({
  icon,
  title,
  text,
  primary,
  secondary,
  testId,
}) => (
  <SMLContainer publicMode header={null}>
    <Row className="justify-content-center m-0">
      <Col md={8} lg={6} className="text-center p-5" data-testid={testId}>
        <FontAwesomeIcon icon={icon} size="3x" className="mb-3 text-muted" aria-hidden="true" />
        <h1 className="h3 mb-3">{title}</h1>
        <p className="mb-4 text-muted">{text}</p>
        <div className="d-flex flex-wrap justify-content-center gap-2">
          <Button color="primary" onClick={primary.onClick}>
            {primary.label}
          </Button>
          {secondary !== undefined && (
            <Button color="secondary" outline onClick={secondary.onClick}>
              {secondary.label}
            </Button>
          )}
        </div>
      </Col>
    </Row>
  </SMLContainer>
);

export const PageUnavailable = TypedMemo(PageUnavailableComponent);
